import { render, staticRenderFns } from "./docChat.vue?vue&type=template&id=42c6313b&scoped=true"
import script from "./docChat.vue?vue&type=script&lang=js"
export * from "./docChat.vue?vue&type=script&lang=js"
import style0 from "./docChat.vue?vue&type=style&index=0&id=42c6313b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.94.0__lodash@4.17.21__ar4y5aobbfwjol7cdxadoh6aqe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6313b",
  null
  
)

export default component.exports